import React, { Component } from 'react';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { MdAccessTime, MdAdd, MdDelete, MdEdit } from 'react-icons/md';
import { URL } from '../../variables';
import { PreferencesContext } from '../../contexts/PreferencesContext';
import TableEmptyState from '../ReusableComponents/TableEmptyState';
import './blocos.css';

class BlocosProcesso extends Component {
    static contextType = PreferencesContext;
    state = {
        blocks: [],
        loading: true,
        saving: false,
        error: '',
        editingId: null,
        showForm: false,
        deleteTarget: null,
        name: '',
        descricao: '',
        type: 'assessment',
        duration_minutes: 60,
        originalDuration: 0,
        timing: {
            total_minutes: 0,
            used_minutes: 0,
            remaining_minutes: 0,
        },
        evaluations: {
            provas: [],
            redacoes: [],
            questionarios: [],
        },
        selected: {
            provas: [],
            redacoes: [],
            questionarios: [],
        },
    };

    componentDidMount() {
        this.loadBlocks();
    }

    requestHeaders = (json = false) => ({
        Accept: 'application/json',
        ...(json ? { 'Content-Type': 'application/json' } : {}),
        'Authorization': `Bearer ${this.props.token}`,
    });

    parseError = (response) => {
        if (!response) return this.context.t('blocks_operation_error');
        if (response.errors) return Object.values(response.errors).join('\n');
        return response.error || this.context.t('blocks_operation_error');
    };

    loadBlocks = () => {
        this.setState({ loading: true, error: '' });
        fetch(`${URL}api/faculdade/get_blocks/${this.props.processo_id}`, {
            headers: this.requestHeaders(),
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.errors || response.error) {
                    this.setState({ error: this.parseError(response) });
                    return;
                }
                this.setState({
                    blocks: response.blocks || [],
                    evaluations: response.evaluations || {
                        provas: [],
                        redacoes: [],
                        questionarios: [],
                    },
                    timing: response.timing || {
                        total_minutes: 0,
                        used_minutes: 0,
                        remaining_minutes: 0,
                    },
                });
            })
            .catch(() => this.setState({ error: this.context.t('blocks_load_error') }))
            .finally(() => this.setState({ loading: false }));
    };

    resetForm = () => {
        this.setState({
            editingId: null,
            showForm: false,
            name: '',
            descricao: '',
            type: 'assessment',
            duration_minutes: 60,
            originalDuration: 0,
            selected: {
                provas: [],
                redacoes: [],
                questionarios: [],
            },
            error: '',
        });
    };

    editBlock = (block) => {
        this.setState({
            editingId: block.id,
            showForm: true,
            name: block.name,
            descricao: block.descricao || '',
            type: block.type,
            duration_minutes: block.duration_minutes,
            originalDuration: Number(block.duration_minutes),
            selected: {
                provas: (block.provas || []).map((item) => item.id),
                redacoes: (block.redacoes || []).map((item) => item.id),
                questionarios: (block.questionarios || []).map((item) => item.id),
            },
            error: '',
        });
    };

    toggleEvaluation = (group, id) => {
        const evaluationId = Number(id);
        const selected = {
            ...this.state.selected,
            [group]: this.state.selected[group].includes(evaluationId)
                ? this.state.selected[group].filter((selectedId) => selectedId !== evaluationId)
                : [...this.state.selected[group], evaluationId],
        };
        this.setState({ selected });
    };

    formatDuration = (minutes) => {
        const absoluteMinutes = Math.abs(Number(minutes) || 0);
        const hours = Math.floor(absoluteMinutes / 60);
        const remainingMinutes = absoluteMinutes % 60;
        if (hours === 0) return `${remainingMinutes} min`;
        if (remainingMinutes === 0) return `${hours}h`;
        return `${hours}h ${remainingMinutes}min`;
    };

    saveBlock = (event) => {
        event.preventDefault();
        const { editingId, name, descricao, type, duration_minutes, selected } = this.state;
        this.setState({ saving: true, error: '' });
        const body = {
            processo_id: this.props.processo_id,
            name,
            descricao,
            type,
            duration_minutes: Number(duration_minutes),
            provas: type === 'interval' ? [] : selected.provas,
            redacoes: type === 'interval' ? [] : selected.redacoes,
            questionarios: type === 'interval' ? [] : selected.questionarios,
        };
        if (editingId) body.id = editingId;

        fetch(`${URL}api/faculdade/${editingId ? 'update_block' : 'store_block'}`, {
            method: 'POST',
            headers: this.requestHeaders(true),
            body: JSON.stringify(body),
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.errors || response.error) {
                    this.setState({ error: this.parseError(response) });
                    return;
                }
                this.resetForm();
                this.loadBlocks();
            })
            .catch(() => this.setState({ error: this.context.t('blocks_save_error') }))
            .finally(() => this.setState({ saving: false }));
    };

    deleteBlock = (block) => {
        fetch(`${URL}api/faculdade/delete_block?id=${block.id}`, {
            method: 'DELETE',
            headers: this.requestHeaders(),
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.errors || response.error) {
                    this.setState({ error: this.parseError(response) });
                    return;
                }
                this.loadBlocks();
            })
            .catch(() => this.setState({ error: this.context.t('blocks_delete_error') }));
    };

    renderEvaluationSummary(block) {
        if (block.type === 'interval') return <span className="block-table-muted">-</span>;
        const groups = [
            { label: this.context.t('tests'), items: block.provas || [] },
            { label: this.context.t('essays'), items: block.redacoes || [] },
            { label: this.context.t('questionnaires'), items: block.questionarios || [] },
        ];

        if (!groups.some((group) => group.items.length > 0)) {
            return <span className="block-table-muted">{this.context.t('blocks_none_linked')}</span>;
        }

        return (
            <div className="block-evaluation-summary">
                {groups.filter((group) => group.items.length > 0).map((group) => (
                    <span key={group.label}><strong>{group.items.length}</strong> {group.label}</span>
                ))}
            </div>
        );
    }

    renderEvaluationSelector() {
        const groups = [
            { key: 'provas', label: this.context.t('tests') },
            { key: 'redacoes', label: this.context.t('essays') },
            { key: 'questionarios', label: this.context.t('questionnaires') },
        ];

        return (
            <div className="block-selection">
                <div className="block-selection-heading">
                    <strong>{this.context.t('blocks_selection_title')}</strong>
                    <small>
                        {this.context.t('blocks_transfer_description')}
                    </small>
                </div>
                <div className="block-selection-grid">
                    {groups.map((group) => (
                        <div className="block-selection-group" key={group.key}>
                            <h6>{group.label}</h6>
                            {this.state.evaluations[group.key].length === 0 && (
                                <span className="block-selection-empty">{this.context.t('empty_no_items_registered')}</span>
                            )}
                            {this.state.evaluations[group.key].map((item) => {
                                const selected = this.state.selected[group.key].includes(Number(item.id));
                                const fromAnotherBlock = item.block && item.block.id !== this.state.editingId;

                                return (
                                    <label className={`block-selection-item ${selected ? 'selected' : ''}`} key={item.id}>
                                        <input
                                            id={`block-${group.key}-${item.id}`}
                                            type="checkbox"
                                            checked={selected}
                                            onChange={() => this.toggleEvaluation(group.key, item.id)}
                                        />
                                        <span>
                                            <strong>{item.name}</strong>
                                            {fromAnotherBlock && <small>{this.context.t('label_currently_in')} {item.block.name}</small>}
                                            {!item.block && <small>{this.context.t('label_without_block')}</small>}
                                        </span>
                                    </label>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    render() {
        const { blocks, loading, saving, error, showForm, timing, originalDuration } = this.state;
        const duration = Number(this.state.duration_minutes) || 0;
        const projectedRemaining = timing.total_minutes - (timing.used_minutes - originalDuration) - duration;
        const modalTitle = this.state.editingId
            ? this.context.t('action_edit_block')
            : this.context.t('action_add_block');

        return (
            <div className="module-card-container blocks-module">
                <div className="module-breadcrumb">
                    <button className="breadcrumb-back" onClick={() => this.props.setState && this.props.setState({ activeTab: -1 })}>
                        {this.context.t('dashboard')}
                    </button>
                    <span>/</span>
                    <strong>{this.context.t('title_blocks')}</strong>
                </div>

                <div className="module-title-row">
                    <div>
                        <h3>{this.context.t('blocks_module_title')}</h3>
                        <p>{this.context.t('blocks_module_description')}</p>
                    </div>
                    <button className="btn-dashboard-modern" onClick={() => this.props.setState && this.props.setState({ activeTab: -1 })}>
                        {this.context.t('legacy_dashboard')}
                    </button>
                </div>

                <div className="module-toolbar blocks-toolbar">
                    <div className="blocks-time-overview">
                        <span>{this.context.t('label_exam_total')}: <strong>{this.formatDuration(timing.total_minutes)}</strong></span>
                        <span>{this.context.t('label_distributed')}: <strong>{this.formatDuration(timing.used_minutes)}</strong></span>
                    </div>
                    <button className="btn-module-primary" onClick={() => this.setState({ showForm: true, error: '' })}>
                        <MdAdd /> {this.context.t('action_add_block')}
                    </button>
                </div>

                {error && !showForm && <div className="badge badge-danger error-message-badge w-100">{error}</div>}

                {!loading && timing.remaining_minutes !== 0 && (
                    <div className={`alert ${timing.remaining_minutes > 0 ? 'alert-warning' : 'alert-danger'} block-time-alert`}>
                        <MdAccessTime />
                        <div>
                            <strong>
                                {timing.remaining_minutes > 0
                                    ? `${this.context.t('blocks_remaining_prefix')} ${this.formatDuration(timing.remaining_minutes)} ${this.context.t('blocks_remaining_suffix')}`
                                    : `${this.context.t('blocks_exceeded_prefix')} ${this.formatDuration(timing.remaining_minutes)}.`}
                            </strong>
                            <span>
                                {this.context.t('label_exam_total')}: {this.formatDuration(timing.total_minutes)}. {this.context.t('label_distributed')}: {this.formatDuration(timing.used_minutes)}.
                            </span>
                        </div>
                    </div>
                )}

                {loading && <div className="blocks-loading"><Spinner animation="border" /></div>}
                {!loading && blocks.length > 0 && (
                    <div className="table-modern-card blocks-table-card">
                        <div className="table-modern-scroll">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>{this.context.t('label_order')}</th>
                                        <th>{this.context.t('label_name')}</th>
                                        <th>{this.context.t('label_type')}</th>
                                        <th>{this.context.t('label_duration_minutes')}</th>
                                        <th>{this.context.t('blocks_linked_evaluations')}</th>
                                        <th>{this.context.t('label_actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {blocks.map((block, index) => (
                                        <tr key={block.id} className={block.type === 'interval' ? 'block-interval-row' : ''}>
                                            <td><span className="block-order">{index + 1}</span></td>
                                            <td>
                                                <div className="block-name-cell">
                                                    <strong>{block.name}</strong>
                                                    {block.descricao && <small>{block.descricao}</small>}
                                                </div>
                                            </td>
                                            <td>
                                                <span className={`block-type-badge ${block.type === 'interval' ? 'interval' : ''}`}>
                                                    {block.type === 'interval' ? this.context.t('block_type_interval') : this.context.t('block_type_assessment')}
                                                </span>
                                            </td>
                                            <td><strong>{this.formatDuration(block.duration_minutes)}</strong></td>
                                            <td>{this.renderEvaluationSummary(block)}</td>
                                            <td>
                                                <div className="actions-group">
                                                    <button className="action-btn info" title={this.context.t('action_edit_block')} onClick={() => this.editBlock(block)}><MdEdit /></button>
                                                    <button className="action-btn danger" title={this.context.t('action_delete_block')} onClick={() => this.setState({ deleteTarget: block })}><MdDelete /></button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {!loading && blocks.length === 0 && (
                    <TableEmptyState title={this.context.t('empty_no_blocks')} description={this.context.t('blocks_empty_description')} icon={<MdAccessTime />} />
                )}

                <Modal show={showForm} onHide={this.resetForm} size="xl" centered dialogClassName="block-form-modal">
                    <Form onSubmit={this.saveBlock}>
                        <Modal.Header closeButton closeLabel="">
                            <Modal.Title>{modalTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {error && <div className="badge badge-danger error-message-badge w-100">{error}</div>}
                            <div className="block-form">
                                <div>
                                    <Form.Label>{this.context.t('label_block_type')}</Form.Label>
                                    <Form.Control as="select" value={this.state.type} onChange={(e) => this.setState({
                                        type: e.target.value,
                                        selected: e.target.value === 'interval'
                                            ? { provas: [], redacoes: [], questionarios: [] }
                                            : this.state.selected,
                                    })}>
                                        <option value="assessment">{this.context.t('block_type_assessment')}</option>
                                        <option value="interval">{this.context.t('block_type_interval')}</option>
                                    </Form.Control>
                                </div>
                                <div>
                                    <Form.Label>{this.context.t('label_name')}</Form.Label>
                                    <Form.Control required value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} placeholder={this.state.type === 'interval' ? this.context.t('placeholder_interval_name') : this.context.t('placeholder_block_name')} />
                                </div>
                                <div>
                                    <Form.Label>{this.context.t('label_duration_minutes')}</Form.Label>
                                    <Form.Control type="number" min="1" required value={this.state.duration_minutes} onChange={(e) => this.setState({ duration_minutes: e.target.value })} />
                                </div>
                                <div className="block-description">
                                    <Form.Label>{this.context.t('label_description')}</Form.Label>
                                    <Form.Control value={this.state.descricao} onChange={(e) => this.setState({ descricao: e.target.value })} placeholder={this.context.t('label_optional')} />
                                </div>
                                <div className={`block-time-summary ${projectedRemaining < 0 ? 'invalid' : ''}`}>
                                    <div><span>{this.context.t('label_exam_total_time')}</span><strong>{this.formatDuration(timing.total_minutes)}</strong></div>
                                    <div><span>{this.context.t('label_already_distributed')}</span><strong>{this.formatDuration(timing.used_minutes - originalDuration)}</strong></div>
                                    <div><span>{projectedRemaining < 0 ? this.context.t('label_exceeded_time') : this.context.t('label_remaining_after_save')}</span><strong>{this.formatDuration(projectedRemaining)}</strong></div>
                                </div>
                                {this.state.type === 'interval' && (
                                    <div className="alert alert-info block-interval-info">
                                        {this.context.t('block_interval_no_evaluations')}
                                    </div>
                                )}
                                {this.state.type === 'assessment' && this.renderEvaluationSelector()}
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" type="button" onClick={this.resetForm}>{this.context.t('legacy_cancelar')}</Button>
                            <Button variant="success" type="submit" disabled={saving || projectedRemaining < 0}>
                                {saving ? <><Spinner animation="border" size="sm" /> {this.context.t('action_saving')}</> : this.context.t('action_save')}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                <SweetAlert
                    warning
                    show={this.state.deleteTarget !== null}
                    title={this.context.t('legacy_atencao')}
                    confirmBtnText={this.context.t('legacy_sim_desejo_apagar')}
                    cancelBtnText={this.context.t('legacy_cancelar')}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel
                    onConfirm={() => {
                        const block = this.state.deleteTarget;
                        this.setState({ deleteTarget: null });
                        if (block) this.deleteBlock(block);
                    }}
                    onCancel={() => this.setState({ deleteTarget: null })}>
                    {this.state.deleteTarget && `${this.context.t('blocks_delete_confirm_prefix')} "${this.state.deleteTarget.name}"? ${this.context.t('blocks_delete_confirm_suffix')}`}
                </SweetAlert>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ token: state.AppReducer.token });

export default connect(mapStateToProps)(BlocosProcesso);
